export const blockIconsTextformattingListNew = (
	<span className='material-symbols-outlined'>list</span>
);
